import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Helmet } from 'react-helmet-async';
import ServiceDetailsHeader from "../../components/Common/ImageHeader";
import CoCreationSection from "../../components/Common/CoCreationSection";
import ExploreSection from "../../components/ProductDetails/ExploreSection";

const ApplicationMigrationServicesPage = () => {
  // Migration Process Data
  const migrationProcessData = [
    {
      id: 1,
      icon: "/svg/Layer_1.svg",
      title: "Assessment & discovery",
      description: "",
    },
    {
      id: 2,
      icon: "/svg/Layer_2.svg",
      title: "Migration roadmap & risk planning",
      description: "",
    },
    {
      id: 3,
      icon: "/svg/Layer_3.svg",
      title: "Cloud architecture design",
      description: "",
    },
    {
      id: 4,
      icon: "/svg/Layer_4.svg",
      title: "Data & application migration execution",
      description: "",
    },
    {
      id: 5,
      icon: "/svg/Layer_5.svg",
      title: "Validation, testing & optimization",
      description: "",
    },
    {
      id: 6,
      icon: "/svg/Layer_5.svg",
      title: "Go-Live support & monitoring",
      description: "",
    },
  ];

  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Application Migration Services | Cloud Enablement & Legacy Modernization in Bangladesh</title>
        <meta 
          name="description" 
          content="Migrate legacy systems with Business Automation Ltd. Get cloud-ready with secure, scalable, and AI-enabled application migration services. Trusted by governments and donor agencies in Bangladesh." 
        />
        <meta 
          name="keywords" 
          content="Application migration services Bangladesh, cloud enablement Bangladesh, legacy software modernization Bangladesh, government IT modernization, AI-powered migration services, data migration and validation Bangladesh, DevOps integration Bangladesh, cloud-native app transformation, public sector cloud solutions, donor-compliant IT migration, software rehosting and refactoring Bangladesh" 
        />
        <link rel="canonical" href="https://www.ba-systems.com/services/application-migration-services" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:url" content="https://ba-systems.com/services/application-migration-services" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Application Migration Services | Cloud Enablement & Legacy Modernization in Bangladesh" />
        <meta property="og:description" content="Migrate legacy systems with Business Automation Ltd. Get cloud-ready with secure, scalable, and AI-enabled application migration services. Trusted by governments and donor agencies in Bangladesh." />
        <meta property="og:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="ba-systems.com" />
        <meta property="twitter:url" content="https://ba-systems.com/services/application-migration-services" />
        <meta name="twitter:title" content="Application Migration Services | Cloud Enablement & Legacy Modernization in Bangladesh" />
        <meta name="twitter:description" content="Migrate legacy systems with Business Automation Ltd. Get cloud-ready with secure, scalable, and AI-enabled application migration services. Trusted by governments and donor agencies in Bangladesh." />
        <meta name="twitter:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />
      </Helmet>
      
      <ServiceDetailsHeader
        title="Application Migration Services"
        subtitle="Seamless Migration to Modern Platforms"
        backgroundImage="/png/bg_ams.png"
        breadcrumbItems={[
          { label: "Home", href: "/" },
          { label: "Services", href: "/our-services" },
          { label: "Application Migration Services", href: "#", isCurrentPage: true },
        ]}
      />

      <Box py={{ base: "30px", md: "40px" }}>
        <Container maxW="7xl">
          <VStack spacing={8} align="start">
            {/* Header Section */}
            <VStack spacing={4} align="start" w="full">
              <Text
                fontSize={{ base: "md", md: "lg" }}
                color="gray.600"
                lineHeight="1.2"
                textAlign="justify"
              >
                In today’s fast-changing digital landscape, organizations must
                move beyond outdated legacy systems to stay competitive, secure,
                and scalable. At Business Automation Limited, we offer end-to-end
                Application Migration Services to help government agencies,
                donor-backed programs, and enterprises shift their core
                applications to modern, cloud-ready environments—securely,
                efficiently, and without disruption.
              </Text>
              <Text
                fontSize={{ base: "md", md: "lg" }}
                color="gray.600"
                lineHeight="1.2"
                textAlign="justify"
              >
                Whether you need to modernize outdated software, migrate
                data-intensive legacy platforms, or re-architect applications
                for cloud-native deployment, we deliver a seamless, structured
                migration experience that minimizes downtime and maximizes
                long-term value.
              </Text>
            </VStack>
            <Heading
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="bold"
              color="gray.800"
            >
              What{" "}
              <Text as="span" color="#000B8C">
                We Offer
              </Text>
            </Heading>
            <Box w="full">
              <img
                src="/png/application.png"
                alt="Application Migration Services"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
                loading="lazy"
              />
            </Box>

            {/* Migration Process Section */}
            <CoCreationSection
              title="Our Migration Process"
              highlightText="Process"
              subtitle=""
              processes={migrationProcessData}
              illustrationImage="/png/app_mig.png"
              bgColor="gray.50"
            />
          </VStack>
          <ExploreSection />
        </Container>
      </Box>
    </>
  );
};

export default ApplicationMigrationServicesPage;
